import { Component, inject, Input, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { CarouselModule } from 'primeng/carousel';
import { Product, ProductService } from '../../../pages/service/product.service';
import { CargarConfService } from '../../../services/cargar-conf.service';
import { aplicacion, RecientesApp } from '../../../interface/data-core';
import { environment } from '../../../../environments/environment';
import { RemoveAccentsPipe } from '../../../pipe/remove-accents.pipe';
import { openUrl } from '../../../utils/generales';
@Component({
    selector: 'app-recientes',
    imports: [CarouselModule, RemoveAccentsPipe],
    templateUrl: './recientes.component.html',
    styleUrl: './recientes.component.css',
    //   encapsulation: ViewEncapsulation.None

})
export class RecientesComponent {
    @Input() public dataAplicaciones: RecientesApp[] = [];


    public _conf = inject(CargarConfService);
    public url_img_app: string = environment.url_img_app;

    list_app: RecientesApp[] = [];
    private readonly url_app: string = environment.url_get_app;

    responsiveOptions: any[] = [];

    constructor() { }

    ngOnInit() {
        this.list_app = this.dataAplicaciones ?? [];

        // co0nsole.info(this.list_app);

        this.responsiveOptions = [
            {
                breakpoint: '1400px',
                numVisible: 2,
                numScroll: 1
            },
            {
                breakpoint: '1199px',
                numVisible: 3,
                numScroll: 1
            },
            {
                breakpoint: '767px',
                numVisible: 2,
                numScroll: 1
            },
            {
                breakpoint: '575px',
                numVisible: 1,
                numScroll: 1
            }
        ]
    }

    getSeverity(status: string) {
        switch (status) {
            case 'INSTOCK':
                return 'success';
            case 'LOWSTOCK':
                return 'warn';
            case 'OUTOFSTOCK':
                return 'danger';
            default:
                return 'info';
        }
    }
    ngOnChanges(changes: SimpleChanges) {
        this.list_app = this.dataAplicaciones ?? []

        // console.debug(this.list_app);
    }

      onOpenApp(id: number): void {
            openUrl(`${this.url_app}${id}`);
        }

    showShareButton(index: number, actividad: aplicacion) {
        const container = document.getElementById(`gshare-${index}`);
        if (container) {
            container.innerHTML = `<g:sharetoclassroom url="${this.getGoogleShareUrl(actividad)}" size="30" theme="classic" itemtype="assignment"></g:sharetoclassroom>`;
            (window as any).gapi?.sharetoclassroom?.go();
        }
    }

    hideShareButton(index: number) {
        const container = document.getElementById(`gshare-${index}`);
        if (container) {
            container.innerHTML = '';
        }
    }

    private getGoogleShareUrl(actividad: aplicacion){
        return `${this.url_app}${actividad.i}`;
    }
}
